import script from "./ReportsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsTab.vue?vue&type=script&setup=true&lang=js"

import "./ReportsTab.vue?vue&type=style&index=0&id=4cf11e9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf11e9d"]])

export default __exports__